export default __webpack_public_path__ + "static/media/login_1.8315e145.jpg";